import { useEffect, useState } from "react";
import { getFeedbackUnread } from "@/lib/apiClient";

export function useFeedbackUnread() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const tick = () => { if (!document.hidden) getFeedbackUnread().then((r) => alive && setCount(r.count)).catch(() => {}); };
    tick();
    const t = setInterval(tick, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return count;
}

export function FeedbackBadge({ className = "" }) {
  const count = useFeedbackUnread();
  if (!count) return null;
  return <span data-testid="feedback-badge" className={`min-w-[20px] h-5 px-1.5 rounded-full bg-[#16BFBF] text-white text-[11px] font-bold flex items-center justify-center ${className}`}>{count}</span>;
}
